<template lang="pug">
#rastreabilidade-raizen
    BaseHeaderRastreabilidade(
        titulo='Rastreabilidade',
        icon='el-icon-plus',
        btnTexto='Inserir Documentos',
        @btnHeaderClicado='goToOrdemDeCorte'
    )
    .view-container-base-header
        FiltroAvancadoRastreabilidade(
            textoPlaceHolder='Busca inteligente (Busque por usina, fazenda ou id do cliente)'
            @atualizar-filtro-avancado='atualizarFiltroAvancado',
        )

        .container-totalizadores
            h2 Totalizadores
            .totalizadores-lista
                VisaoGeralCardTotalizadorRastreabilidade(
                    etapa='Número de CAR'
                    texto='teste',
                    :numero='totalNumeroCarCadastrado',
                    :hectares='totalAreaCar',
                    icone='car'
                )
                VisaoGeralCardTotalizadorRastreabilidade(
                    etapa='Número de Fazendas'
                    texto='teste',
                    :numero='totalNumeroFazendasCadastrado',
                    :hectares='totalAreaFazendas',
                    icone='fazendas'
                )
                VisaoGeralCardTotalizadorRastreabilidade(
                    etapa='Número de Talhões'
                    texto='teste',
                    :numero='totalNumeroTalhoesCadastrado',
                    :hectares='totalAreaTalhoes',
                    icone='talhoes'
                )

        .container-graficos
            div
                h2 Saldo de Açúcar
                .grafico
                    GraficoAcucarRastreabilidade(:grafico_acucar='grafico_acucar', :dadosTabela='dadosGraficoAcucar', :seriesGraficoAcucar='seriesGraficoAcucar')
                    .container-img
                        BaseButton.btn-grafico(
                            icon='mdi mdi-chart-line',
                            style='justify-content=space-between',
                            @click="alterar_graf_acucar('linha')"
                        )
                        BaseButton.btn-grafico(
                            icon='mdi mdi-chart-bar',
                            style='justify-content=space-between',
                            @click="alterar_graf_acucar('barra')"
                        )
                        BaseButton.btn-grafico(
                            icon='mdi mdi-table',
                            style='justify-content=space-between',
                            @click="alterar_graf_acucar('tabela')"
                        )
            div
                h2 Saldo de Etanol
                .grafico
                    GraficoEtanolRastreabilidade(:grafico_etanol='grafico_etanol', :dadosTabela='dadosGraficoEtanol', :seriesGraficoEtanol='seriesGraficoEtanol')
                    .container-img
                        BaseButton.btn-grafico(
                            icon='mdi mdi-chart-line',
                            style='justify-content=space-between',
                            @click="alterar_graf_etanol('linha')"
                            )
                        BaseButton.btn-grafico(
                            icon='mdi mdi-chart-bar',
                            style='justify-content=space-between',
                            @click="alterar_graf_etanol('barra')"
                        )
                        BaseButton.btn-grafico(
                            icon='mdi mdi-table',
                            style='justify-content=space-between',
                            @click="alterar_graf_etanol('tabela')"
                        )

        .row
            .col-12
                .mapa
                    mapa(
                        ref='map',
                        :idMapa='"mapaVisaoGeral"',
                        :mapLayersConfigs='camadasMapa',
                        :mapConfig='configuracoesMapa',
                        :camadaCentralizadaNome='camadaCentralizadaNome',
                    )
            
            ModalInformacaoTerritorio(
                :mostrar='mostrarModalInformacaoTerritorio'
            )

        Footer
</template>

<script>
import BaseHeaderRastreabilidade from '@/components/rastreabilidadeRaizen/BaseHeaderRastreabilidade';
import FiltroRastreabilidade from '@/components/rastreabilidadeRaizen/FiltroRastreabilidade';
import FiltroAvancadoRastreabilidade from '@/components/rastreabilidadeRaizen/FiltroAvancadoRastreabilidade';
import VisaoGeralCardTotalizadorRastreabilidade from '@/components/rastreabilidadeRaizen/VisaoGeralCardTotalizadorRastreabilidade';
import GraficoAcucarRastreabilidade from '@/components/rastreabilidadeRaizen/GraficoAcucarRastreabilidade';
import GraficoEtanolRastreabilidade from '@/components/rastreabilidadeRaizen/GraficoEtanolRastreabilidade';
import ModalInformacaoTerritorio from '@/components/rastreabilidadeRaizen/visaoGeral/ModalInformacaoTerritorio';
import PopupMapaRastreabilidade from '@/components/rastreabilidadeRaizen/PopupMapaRastreabilidade';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

import RastreabilidadeSaldoDeProducaoService from '@/services/RastreabilidadeSaldoDeProducaoService';
import RastreabilidadeVisaoGeralService from '@/services/RastreabilidadeVisaoGeralService';

import Mapa from '@/components/MapaLeaflet';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import L from 'leaflet';
import InstanciarComponente from '@/utils/InstanciarComponenteVue';

const ICONE_PONTO_MAPA = L.icon({
    iconUrl: 'https://lyra-v1.s3.amazonaws.com/marker-icon.png',
    iconSize: [18, 26]
});

export default {
    name: 'CompartilhamentoDadosIndex',
    components: {
        BaseHeaderRastreabilidade,
        FiltroRastreabilidade,
        FiltroAvancadoRastreabilidade,
        VisaoGeralCardTotalizadorRastreabilidade,
        GraficoAcucarRastreabilidade,
        GraficoEtanolRastreabilidade,
        Mapa,
        ModalInformacaoTerritorio,
        PopupMapaRastreabilidade,
        BaseButton
    },
    props: {
        grafico_etanol: {
            type: String,
            default: () => 'barra'
        },
        grafico_acucar: {
            type: String,
            default: () => 'linha'
        }
    },
    data() {
        return {
            territoriosSelecionados: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                idsUsuarios: [],
                situacao: null,
                dataCadastroInicio: '',
                dataCadastroFim: ''
            },
            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: true,
                diagnostico: true
            },
            territorios: [],
            territoriosBuffer: [],
            camadaCentralizadaNome: null,
            dadosGraficoAcucar: [],
            seriesGraficoAcucar: [],
            seriesGraficoEtanol: [],
            dadosGraficoEtanol: [],
            totalAreaCar: '',
            totalAreaFazendas: '',
            totalAreaTalhoes: '',
            totalNumeroCarCadastrado: '',
            totalNumeroFazendasCadastrado: '',
            totalNumeroTalhoesCadastrado: '',
            buscandoInformacoes: false,
            mostrarModalInformacaoTerritorio: false,
            idMunicipio: null,
            usuariosBuffer: {},
            modalFiltroAvancado: false,
            filtro: {
                textoBusca: '',
                dataInicioPesquisa: '',
                dataFimPesquisa: '',
                fazendasCertificadas: false
            },
            mapaEstaCarregado: false,
            ultimoTextobusca: ''
        };
    },
    async mounted() {

    },
    computed: {
        usuario() {
            return this.$store.state.usuarioLogado;
        }
    },
    async created() {
        this.atualizarFiltroAvancado(this.filtro);
    },
    methods: {
        criarPopup(data) {
            const instance = InstanciarComponente(
                PopupMapaRastreabilidade,
                { mapa: this.$refs.map.mapa, data}
            );

            L.marker([51.5, -0.09], { icon: ICONE_PONTO_MAPA })
                .addTo(this.$refs.map.mapa)
                .bindPopup(instance.$el)
                .openPopup();

           return instance.$el;
        },
        
        async mostrarTerritorios(dadosTerritorioComGeometria) {
            this.camadasMapa = [];
            this.territorios = [];
            
            dadosTerritorioComGeometria.forEach(fazenda => {
                    
                this.camadasMapa.push({
                        id: fazenda.idTerritorio,
                        name: 'territorioExibido' + fazenda.idTerritorio,
                        geoJson: fazenda.territorio.geometria
                    });

                    this.camadasMapa.push({
                        id: fazenda.idTerritorio,
                        name: 'territorioExibido' + fazenda.idTerritorio,
                        geoJson: fazenda.territorio.centroide,
                        icon: ICONE_PONTO_MAPA,
                        popup: this.criarPopup(fazenda),
                        style: getEstiloGeometria('area')
                    });
            });
            this.mapaEstaCarregado = true;
        },

        escolherTerritorioMapa(id) {
            this.camadasMapa = [];
            const territorioEscolhido = this.territorios.find(territorio => territorio.id === id);

            try {
                this.camadasMapa.push({
                    name: 'centroid' + id,
                    geoJson: territorioEscolhido.centroide,
                    popup: this.criarPopup(territorioEscolhido),
                    style: getEstiloGeometria('area')
                });

            } catch (error) {
                this.$notify.error({
                    message: 'Ocorreu um erro ao exibir o território'
                });
            }
            this.camadaCentralizadaNome = 'territorioExibido' + id;
        },

        goToOrdemDeCorte() {
            this.$router.push({ name: 'OrdemDeCorte' });
        },

        buscarUrlImagem(nome) {
            return require(`@/assets/raizen-icons/rastreabilidade/${nome}.png`);
        },

        alterar_graf_acucar(tipo) {
            this.grafico_acucar = tipo;
        },

        alterar_graf_etanol(tipo) {
            this.grafico_etanol = tipo;
        },

        async buscarTerritoriosGeometriaFazenda(textoBusca) {

            const { data } = await RastreabilidadeVisaoGeralService.buscarTerritoriosGeometriaFazenda(textoBusca);
            this.mostrarTerritorios(data.itens);
        },

        async buscarSaldoProducaoGraficos(textoBusca) {
            this.buscandoInformacoes = true;
            const { data } = await RastreabilidadeSaldoDeProducaoService.buscarSaldoProducaoGraficos(textoBusca);
            
            this.montarGraficos(data);

            this.buscandoInformacoes = false;
        },
        
        async buscarTotalizadoresVisaoGeral(filtro) {
            this.buscandoInformacoes = true;
            const { data } = await RastreabilidadeVisaoGeralService.buscarTotalizadoresVisaoGeral(filtro);

            this.totalAreaCar = data.totalAreaCar;
            this.totalAreaFazendas = data.totalAreaFazendas;
            this.totalAreaTalhoes = data.totalAreaTalhoes;
            this.totalNumeroCarCadastrado = data.totalNumeroCarCadastrado.toString();
            this.totalNumeroFazendasCadastrado = data.totalNumeroFazendasCadastrado.toString();
            this.totalNumeroTalhoesCadastrado = data.totalNumeroTalhoesCadastrado.toString();

            this.buscandoInformacoes = false;
        },

        montarGraficos(dados) {
          
            let dadosGraficoValoresEntrada = [];
            let dadosGraficoValoresSaida = [];
            let dadosGraficoValoresSaldo = [];
            this.dadosGraficoAcucar = [];
          
            let semanaContador = 1;
            dados.itensAcucar.forEach(element => {
                if (semanaContador <= 4) {
                    dadosGraficoValoresEntrada.push(element.valorEntrada);
                    dadosGraficoValoresSaida.push(element.valorSaida);
                    dadosGraficoValoresSaldo.push(element.valorSaldo);
                    this.dadosGraficoAcucar.push(element);
                }
                semanaContador++;
            });
            this.seriesGraficoAcucar = [];
            this.seriesGraficoAcucar.push({name: 'Entrada de Volume', data: dadosGraficoValoresEntrada});
            this.seriesGraficoAcucar.push({name: 'Saida de Volume', data: dadosGraficoValoresSaida});
            this.seriesGraficoAcucar.push({name: 'Saldo', data: dadosGraficoValoresSaldo});

            dadosGraficoValoresEntrada = [];
            dadosGraficoValoresSaida = [];
            dadosGraficoValoresSaldo = [];
            this.dadosGraficoEtanol = [];

            semanaContador = 1;

            dados.itensEtanol.forEach(element => {
                if (semanaContador <= 4) {
                    dadosGraficoValoresEntrada.push(element.valorEntrada);
                    dadosGraficoValoresSaida.push(element.valorSaida);
                    dadosGraficoValoresSaldo.push(element.valorSaldo);
                    this.dadosGraficoEtanol.push(element);
                }
                semanaContador++;
            });
            this.seriesGraficoEtanol = [];
            this.seriesGraficoEtanol.push({name: 'Entrada de Volume', data: dadosGraficoValoresEntrada});
            this.seriesGraficoEtanol.push({name: 'Saida de Volume', data: dadosGraficoValoresSaida});
            this.seriesGraficoEtanol.push({name: 'Saldo', data: dadosGraficoValoresSaldo});

        },

        atualizarFiltroAvancado(filtroAvancado) {
            this.buscarTerritoriosGeometriaFazenda(filtroAvancado);
            this.buscarSaldoProducaoGraficos(filtroAvancado);
            this.buscarTotalizadoresVisaoGeral(filtroAvancado);
        },
        showFiltroAvancado() {
            this.modalFiltroAvancado = !this.modalFiltroAvancado;
        }
    }
};
</script>

<style scoped lang="scss">
#rastreabilidade-raizen {

    .compart-btn {
        justify-content: flex-end;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .m-top {
        margin-top: 25px;
    }

    .container-totalizadores {
        padding: 20px 35px 0px 20px;

        h2 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--black);
            font-weight: bold;
        }
        .totalizadores-lista {
            width: 100%;
            height: 99px;
            margin: 0 auto;
            display: grid;
            gap: 12px;
            grid-template-columns: 33% 33% 33%;
        }

        .totalizadores-bloco {
            width: 32%;
        }
    }

    .view-container-base-header{
        .container-graficos {
            padding: 20px 35px 0px 20px;
            
            h2 {
                margin-bottom: 10px;
                margin-top: 10px;
                color: var(--black);
                font-weight: bold;
            }
            .grafico{
                background: #FEFEFE;
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
                border-radius: 5px;
            }

            .container-img {
                justify-content: center;
                align-items: center;
                width: 100%;
                display: flex;
                gap: 12px;
                grid-template-columns: 5% 5% 5%;
                box-sizing: border-box;
                padding-bottom: 10px;
            }

            .btn-grafico{
                justify-content: center;
                display: flex;
                width: 45px;
                height: 41px;
                background: #FFFFFF;
                border: 0.5px solid #00413C;
                border-radius: 5px;
            }

            height: 600px;
            width: 100%;
            display: grid;
            gap: 10%;
            grid-template-columns: 45% 45%;
        }

        .mapa {
            height: 600px;
            border-radius: 5px;
        }
    }

    .filtros {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .filtros-avancados__cabecalho {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .filtros-avancados__aplicar-filtro {
        cursor: pointer;
        border: 1px solid #eeeeee;
        border-radius: 20px;
        padding: 4px 8px;
        color: var(--primary);
    }

    .filtros-avancados__collapse--alinhamento {
        display: flex;
        .el-select {
            margin-right: 3px;
        }
    }

}
</style>
